export default {
  debug: 'warn',
  content: '',
  modules: {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike', 'link', {'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'color': [] }, { 'background': [] }]
      ]
    }
  },
  placeholder: 'Your description goes here ...',
  theme: 'snow'
}



// WEBPACK FOOTER //
// ./src/scripts/editor-options.js